import React from 'react';

const CaratLeft = props => (
  <svg viewBox="0 0 28 28" {...props}>
    <path d="M21.453 27.404a1.728 1.728 0 00-.199-2.365L10.449 14 21.254 2.964c.688-.61.774-1.652.199-2.369a1.68 1.68 0 00-2.365-.2L6.767 12.715a1.681 1.681 0 000 2.566l12.321 12.32a1.683 1.683 0 002.365-.197z" />
  </svg>
);

export default CaratLeft;
